// go-chat-duplication
import { Directive, OnInit, inject, input } from '@angular/core';

import { GoPrimaryNotificationComponent } from './go-primary-notification/go-primary-notification.component';
import { GoDashboardNotification } from './go-dashboard-notification';
import { GoDatabaseNotificationType } from '@shared/services/go-notifications/go-database-notification-type';

@Directive({
  selector: '[appGoAssignedPatientNotification]',
})
export class GoAssignedPatientNotificationDirective implements OnInit {
  private primaryNotificationComponent = inject(GoPrimaryNotificationComponent, { host: true });

  readonly notificationData = input.required<GoDatabaseNotificationType>();

  ngOnInit() {
    const { patientId, fromTherapistFirstName, fromTherapistLastName } = this.notificationData().data;

    const therapistName = `${fromTherapistFirstName} ${fromTherapistLastName}`;
    const timestamp = this.notificationData().ts;
    const readAtTime = this.notificationData().read;
    const id = this.notificationData().id;

    const icon = 'folder_shared';
    const link = `/therapist/assigned-patients/patient-profile/${patientId}`;
    const title = 'Patient Record Shared';
    const message = `A patient record has been shared with you by ${therapistName}.`;

    this.primaryNotificationComponent.notification.set(
      new GoDashboardNotification(icon, link, title, message, timestamp, readAtTime, id)
    );
  }
}
